<template>
  <section class="blog-hero" aria-labelledby="blog-hero-title">
    <img
      src="@/assets/images/zinnes-banner-desfoque.png"
      alt="Ilustração de leitores e criadores no universo Zinnes"
      class="blog-hero__art"
      width="3200"
      height="1840"
      fetchpriority="high"
      decoding="async"
    />
    <div class="blog-hero__content">
      <p class="blog-hero__eyebrow">Portal definitivo do fã</p>
      <h1 id="blog-hero-title" class="blog-hero__title">
        Seu Portal de <span class="blog-hero__title-accent">Notícias Nacionais</span>
      </h1>
      <p class="blog-hero__lead">
        Descubra notícias, histórias e seu próximo personagem nacional favorito! — Aqui você acompanha tudo o que acontece no cenário geek brasileiro.
      </p>
      <button
        v-if="canPublish"
        type="button"
        class="zinnes-primary-btn blog-hero__cta"
        @click="$emit('publish')"
      >
        Publicar uma matéria
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "BlogHero",
  props: {
    canPublish: { type: Boolean, default: false },
  },
};
</script>